import { createSlice } from '@reduxjs/toolkit'

const successModalSlice = createSlice({
  name: 'successModalState',
  initialState: {
    open: false,
    data: {
        title: '',
        subtitle: '',
        callback: () => {}
    }
  },
  reducers: {
    setSuccessModalOpen: (state, action) => {
      state.open = action.payload
    },
    setSuccessModalData: (state, action) => {
      state.data = action.payload
    }
  }
})

export const { setSuccessModalOpen, setSuccessModalData } = successModalSlice.actions

export default successModalSlice.reducer